import { SpotlightTransition } from '@atlaskit/onboarding';
import { useState } from 'react';

import { FilterSpotlight } from './FilterSpotlight';
import { MoreActionsSpotlight } from './MoreActionsSpotlight';

export const HighImpactSpotlightTour = ({ onDismiss }: { onDismiss: () => void }) => {
	const [activeSpotlight, setActiveSpotlight] = useState<null | number>(0);

	const next = () => setActiveSpotlight((activeSpotlight || 0) + 1);

	const endTour = () => {
		setActiveSpotlight(null);
		onDismiss();
	};

	const renderActiveSpotlight = () => {
		const spotlights = [
			<FilterSpotlight key="filter-spotlight" onNext={next} onDismiss={endTour} />,
			<MoreActionsSpotlight key="more-actions-spotlight" onFinish={endTour} />,
		];

		if (activeSpotlight === null) {
			return null;
		}

		return spotlights[activeSpotlight];
	};

	if (activeSpotlight === null) {
		return null;
	}

	return <SpotlightTransition>{renderActiveSpotlight()}</SpotlightTransition>;
};
